// extracted by mini-css-extract-plugin
module.exports = {"header":"ProductHeader_header__E28BE","is-visible":"ProductHeader_is-visible__I7vJQ"};